<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="起始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" v-model="params.operator_id" multiple collapse-tags placeholder="用户" filterable @visible-change="getSelectList('user')">
                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.type" multiple collapse-tags placeholder="操作类型" @visible-change="getSelectList('operationType')">
                    <el-option v-for="list in selectMap.operationType" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.remark" placeholder="操作内容"></el-input>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
</style>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                loading : false,
				list:[],
				options: [],
				admin_option : [],
				start_time : '',
				end_time : new Date(),
				params : {
					per_page : 50,
					page : 1,
					start_time : '',
					end_time : '',
					operator_id : '',
					type : '',
					remark : ""
				},
				last_page : 1,
                total : 0,
                selectMap:{
                    user:[],
                    operationType:[]
                },
                tableCol:[
                    {colName:"操作时间",colKey:"create_time",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"用户名",colKey:"operator_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"操作类型",colKey:"operate_type",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"操作日志",colKey:"remark",colWidth:400,isSetWidth:true,isCanClick:false,isShow:true,isOpreationLog:true},
                    {colName:"IP",colKey:"ip",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"IP地址",colKey:"location",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true}
                ],
            }
        },
        created() {
			this.getList();
		},
        mounted(){
            this.start_time = this.$getDateOneYearAgo();
        },
        methods:{
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            reset(){
                this.start_time = "";
                this.end_time = "";
				this.params= {per_page : 50,page : 1,start_time : '',end_time : '',operater_id : '',type : '',remark : ""}
                this.getList();
			},
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.loading = true;
				this.params.start_time = this.formatTimeZero(this.start_time);
                this.params.end_time =  this.formatTimeZero(this.end_time);
                this.tableLoading = true;
                this.postFunc("/erp/system.operate.log",this.params,response=>{
                    if(response.data.code == 0){
                        // this.params.page = parseInt(response.data.data.current_page);
                        this.$refs.pagination.flag = true;
                        this.tableLoading = false;
                        this.last_page = parseInt(response.data.data.last_page);
                        this.total = parseInt(response.data.data.total);
                        this.list = response.data.data.data;
                        this.list.forEach((item,index)=>{
                            this.list[index].create_time = this.formatTimeSecond(item.create_time*1000)
                        })
					}
					this.loading = false;
                },error=>{
                    this.loading = false;
                    this.tip(error.data.message,"warning")
                })
            },
            search(){
				if(this.params.page == 1){
					this.getList();
				} else {
					this.params.page = 1;
                }
                this.getList()
			},
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
			'params.page':function(){
				this.getList();
            },
            'params.per_page':function(){
				this.getList();
			}
		}
    }
</script>
